<script>

import Layout from "../../layouts/main";

import PageHeader from "@/components/page-header";

import appConfig from "@/app.config";

import Loader from "@/components/widgets/loader.vue";

import Detay from "./detay.vue"



export default {

  page: {

    title: "Genel Muhasebe Raporu",

    meta: [

      {

        name: "description",

        content: appConfig.description,

      },

    ],

  },

  components: {

    Layout,

    PageHeader,

    Loader,

    Detay 

  },

  data() {

    return {

        list: {},

        title: "MUHASEBE GENEL",

        items: [

          {

            text: "ANASAYFA",

            href: "/",

          },

          {

            text: "MUHASEBE GENEL",

            active: true,

          },

        ],

        openId:[],

        isLoading: true,

        form:{

          company:'0'

        },

        rows: [],

        detayData:{},

        total:0,

    };

  },

  computed: {

    companyLabel() {

      const map = { '0': 'Tüm', '1': 'Primenet', '2': 'Elworks' };

      return map[this.form.company] || 'Tüm';

    },

    rowsList() {

      if (Array.isArray(this.rows)) return this.rows;

      return Object.values(this.rows || {});

    },

    typeTotals() {

      const map = {};

      this.rowsList.forEach((row) => {

        (row.islemler || []).forEach((r) => {

          const key = r.title;

          map[key] = (map[key] || 0) + parseFloat(r.total || 0);

        });

      });

      return Object.keys(map).map((title) => ({ title, total: map[title] }));

    },

    grandTotal() {

      return this.rowsList.reduce((sum, row) => sum + parseFloat(row.total || 0), 0);

    },

  },

   mounted() {

    this.date()

    this.loadItems()

  },

  methods: {

    date(){

        var currentDate = new Date();

        var firstDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

        var lastDay = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

        this.form.startdate= this.formatDate(firstDay),

        this.form.startdateend= this.formatDate(lastDay)

    },



    formatDate(date) {

        var day = date.getDate();

        var month = date.getMonth() + 1;

        var year = date.getFullYear();



        day = day < 10 ? '0' + day : day;

        month = month < 10 ? '0' + month : month;

        

        return year + '-' + month + '-' + day;

    },

  

    loadItems() {

      this.isLoading = true

      this.$http.post("/accountant/genel", this.form)

            .then(response => {

                this.rows= response.data



                const data = response.data;

                let toplam = 0;

                for (const key in data) {

                    toplam += parseFloat(data[key].total);

                }

                this.total = toplam

                this.isLoading = false

            })

    },



    formSubmit() {

        this.loadItems()

    },



    detay(props){

       this.odemeAlDetay = props

       this.$parent.$bvModal.show('odeme_al')

    },



    toggle(id){

      let indeks = this.openId.indexOf(id);



      if (indeks !== -1) {

        this.openId.splice(indeks, 1);

      }else{

        this.openId.push(id)

      }

    },



    detail(props, bayidata){

      this.detayData = { odemeTuru:props.type_id , ...bayidata, ...this.form } 

      this.$parent.$bvModal.show('detay_modal')

    }

  },

};

</script>



<template>

  <Layout>

    <Detay :data="detayData" />

    <PageHeader :title="title" :items="items" />



    <div class="sahsi-page">

      <div class="sahsi-filter">

        <div class="sahsi-filter__head">

          <div>

            <p class="sahsi-filter__eyebrow">Filtre</p>

            <h5 class="sahsi-filter__title">Rapor Kriterleri</h5>

          </div>

          <div class="sahsi-filter__badges">

            <span class="sahsi-filter__range-badge">

              <i class="bx bx-buildings"></i>

              {{ companyLabel }}

            </span>

            <span class="sahsi-filter__range-badge" v-if="form.startdate && form.startdateend">

              <i class="bx bx-calendar"></i>

              {{ form.startdate }} — {{ form.startdateend }}

            </span>

          </div>

        </div>

        <form class="sahsi-filter__form" @submit.prevent="formSubmit">

          <div class="sahsi-field sahsi-field--company">

            <label>Şirket</label>

            <select v-model="form.company" class="sahsi-input">

              <option value="0">Tüm</option>

              <option value="1">Primenet</option>

              <option value="2">Elworks</option>

            </select>

          </div>

          <div class="sahsi-filter__dates">

            <div class="sahsi-field">

              <label>Başlangıç</label>

              <input type="date" class="sahsi-input" v-model="form.startdate">

            </div>

            <span class="sahsi-filter__sep">—</span>

            <div class="sahsi-field">

              <label>Bitiş</label>

              <input type="date" class="sahsi-input" v-model="form.startdateend">

            </div>

          </div>

          <button type="submit" class="sahsi-btn sahsi-btn--primary" :disabled="isLoading">

            <i class="bx bx-search-alt" :class="{ 'bx-spin': isLoading }"></i>

            Sorgula

          </button>

        </form>

      </div>



      <div class="sahsi-summary" v-if="!isLoading && rowsList.length">

        <div class="sahsi-summary__item">

          <span class="sahsi-summary__label">Kayıt Sayısı</span>

          <strong class="sahsi-summary__value">{{ rowsList.length }}</strong>

        </div>

        <div class="sahsi-summary__item sahsi-summary__item--total">

          <span class="sahsi-summary__label">Toplam Bakiye</span>

          <strong class="sahsi-summary__value">{{ $paraFormat(grandTotal) }}</strong>

        </div>

      </div>



      <Loader :loading="true" :load="isLoading">

        <div class="sahsi-panel">

          <div class="sahsi-panel__header">

            <div>

              <h5 class="sahsi-panel__title"><i class="bx bx-user me-2"></i>Kullanıcı Listesi</h5>

              <p class="sahsi-panel__sub">Satıra tıklayarak işlem detaylarını görüntüleyin</p>

            </div>

          </div>



          <div v-if="rowsList.length === 0" class="sahsi-empty">

            <i class="bx bx-folder-open"></i>

            <p>Kayıt bulunamadı</p>

          </div>



          <div v-else class="sahsi-list">

            <div

              v-for="(row, i) in rowsList"

              :key="i"

              class="sahsi-row"

              :class="{ 'is-open': openId.includes(i) }"

            >

              <div class="sahsi-row__main" @click="toggle(i)">

                <div class="sahsi-row__left">

                  <span class="sahsi-row__avatar">{{ (row.name || '?').charAt(0).toUpperCase() }}</span>

                  <div>

                    <strong class="sahsi-row__name">{{ row.name }}</strong>

                    <span class="sahsi-row__meta">{{ row.islemler ? row.islemler.length : 0 }} işlem türü</span>

                  </div>

                </div>

                <div class="sahsi-row__right">

                  <span class="sahsi-row__amount">{{ $paraFormat(row.total) }}</span>

                  <i class="bx sahsi-row__chevron" :class="openId.includes(i) ? 'bx-chevron-up' : 'bx-chevron-down'"></i>

                </div>

              </div>



              <div class="sahsi-row__detail" v-if="openId.includes(i)">

                <div

                  v-for="(r, idx) in row.islemler"

                  :key="`c${idx}`"

                  class="sahsi-detail-item"

                >

                  <span class="sahsi-detail-item__type">{{ r.title }}</span>

                  <span class="sahsi-detail-item__amount">{{ $paraFormat(r.total) }}</span>

                  <button class="sahsi-detail-item__btn" type="button" @click.stop="detail(r, row)">

                    <i class="bx bx-search-alt-2"></i>

                    Detay

                  </button>

                </div>

              </div>

            </div>

          </div>



          <div class="sahsi-totals" v-if="rowsList.length">

            <div class="sahsi-totals__row" v-for="item in typeTotals" :key="item.title">

              <span>{{ item.title }}</span>

              <strong>{{ $paraFormat(item.total) }}</strong>

            </div>

            <div class="sahsi-totals__row sahsi-totals__row--grand">

              <span>Toplam</span>

              <strong>{{ $paraFormat(grandTotal) }}</strong>

            </div>

          </div>

        </div>

      </Loader>

    </div>
 
  </Layout>

</template>



<style scoped>

.sahsi-page {

  display: flex;

  flex-direction: column;

  gap: 20px;

}



.sahsi-filter {

  background: #fff;

  border: 1px solid #e2e8f0;

  border-radius: 16px;

  padding: 22px 24px;

  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);

}



.sahsi-filter__head {

  display: flex;

  align-items: flex-start;

  justify-content: space-between;

  gap: 16px;

  margin-bottom: 18px;

  flex-wrap: wrap;

}



.sahsi-filter__badges {

  display: flex;

  flex-wrap: wrap;

  gap: 8px;

}



.sahsi-filter__eyebrow {

  margin: 0 0 4px;

  font-size: 11px;

  font-weight: 700;

  letter-spacing: 0.08em;

  text-transform: uppercase;

  color: #2563eb;

}



.sahsi-filter__title {

  margin: 0;

  font-size: 1.05rem;

  font-weight: 700;

  color: #0f172a;

}



.sahsi-filter__range-badge {

  display: inline-flex;

  align-items: center;

  gap: 6px;

  padding: 8px 14px;

  border-radius: 999px;

  background: #f1f5f9;

  font-size: 12px;

  font-weight: 600;

  color: #475569;

}



.sahsi-filter__form {

  display: flex;

  align-items: flex-end;

  gap: 16px;

  flex-wrap: wrap;

}



.sahsi-field--company {

  min-width: 160px;

  flex: 0 0 160px;

}



.sahsi-filter__dates {

  display: flex;

  align-items: flex-end;

  gap: 12px;

  flex: 1;

  min-width: 280px;

}



.sahsi-filter__sep {

  color: #94a3b8;

  padding-bottom: 10px;

  font-weight: 600;

}



.sahsi-field {

  flex: 1;

  min-width: 140px;

}



.sahsi-field label {

  display: block;

  font-size: 12px;

  font-weight: 600;

  color: #64748b;

  margin-bottom: 6px;

}



.sahsi-input {

  width: 100%;

  height: 42px;

  padding: 0 12px;

  border: 1px solid #e2e8f0;

  border-radius: 10px;

  font-size: 14px;

  color: #0f172a;

  background: #f8fafc;

  transition: border-color 0.2s, box-shadow 0.2s;

}



.sahsi-input:focus {

  outline: none;

  border-color: #2563eb;

  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);

  background: #fff;

}



.sahsi-btn {

  display: inline-flex;

  align-items: center;

  justify-content: center;

  gap: 8px;

  height: 42px;

  padding: 0 22px;

  border: none;

  border-radius: 10px;

  font-size: 14px;

  font-weight: 600;

  cursor: pointer;

  transition: transform 0.15s, box-shadow 0.15s;

}



.sahsi-btn--primary {

  background: linear-gradient(135deg, #2563eb, #1d4ed8);

  color: #fff;

  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.25);

}



.sahsi-btn--primary:hover:not(:disabled) {

  transform: translateY(-1px);

  box-shadow: 0 8px 22px rgba(37, 99, 235, 0.32);

}



.sahsi-btn:disabled {

  opacity: 0.7;

  cursor: not-allowed;

}



.sahsi-summary {

  display: grid;

  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));

  gap: 14px;

}



.sahsi-summary__item {

  background: #fff;

  border: 1px solid #e2e8f0;

  border-radius: 14px;

  padding: 16px 20px;

  display: flex;

  flex-direction: column;

  gap: 4px;

}



.sahsi-summary__item--total {

  background: linear-gradient(135deg, #ecfdf5, #f0fdf4);

  border-color: #bbf7d0;

}



.sahsi-summary__label {

  font-size: 12px;

  color: #64748b;

  font-weight: 600;

}



.sahsi-summary__value {

  font-size: 1.35rem;

  color: #0f172a;

  line-height: 1.2;

}



.sahsi-summary__item--total .sahsi-summary__value {

  color: #059669;

}



.sahsi-panel {

  background: #fff;

  border: 1px solid #e2e8f0;

  border-radius: 16px;

  overflow: hidden;

  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);

}



.sahsi-panel__header {

  padding: 20px 22px 0;

}



.sahsi-panel__title {

  margin: 0;

  font-size: 1rem;

  font-weight: 700;

  color: #0f172a;

}



.sahsi-panel__sub {

  margin: 4px 0 0;

  font-size: 13px;

  color: #64748b;

}



.sahsi-empty {

  display: flex;

  flex-direction: column;

  align-items: center;

  justify-content: center;

  gap: 10px;

  padding: 48px 20px;

  color: #94a3b8;

}



.sahsi-empty i {

  font-size: 2.5rem;

}



.sahsi-list {

  padding: 16px 18px;

  display: flex;

  flex-direction: column;

  gap: 10px;

}



.sahsi-row {

  border: 1px solid #eef2f7;

  border-radius: 12px;

  overflow: hidden;

  transition: border-color 0.2s, box-shadow 0.2s;

}



.sahsi-row.is-open {

  border-color: #bfdbfe;

  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.08);

}



.sahsi-row__main {

  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 16px;

  padding: 14px 16px;

  cursor: pointer;

  background: #fafbfc;

  transition: background 0.15s;

}



.sahsi-row__main:hover {

  background: #f1f5f9;

}



.sahsi-row.is-open .sahsi-row__main {

  background: #eff6ff;

}



.sahsi-row__left {

  display: flex;

  align-items: center;

  gap: 12px;

  min-width: 0;

}



.sahsi-row__avatar {

  width: 40px;

  height: 40px;

  border-radius: 10px;

  background: linear-gradient(135deg, #dbeafe, #bfdbfe);

  color: #1d4ed8;

  font-weight: 700;

  font-size: 16px;

  display: flex;

  align-items: center;

  justify-content: center;

  flex-shrink: 0;

}



.sahsi-row__name {

  display: block;

  font-size: 14px;

  color: #0f172a;

}



.sahsi-row__meta {

  display: block;

  font-size: 12px;

  color: #94a3b8;

  margin-top: 2px;

}



.sahsi-row__right {

  display: flex;

  align-items: center;

  gap: 12px;

  flex-shrink: 0;

}



.sahsi-row__amount {

  font-size: 15px;

  font-weight: 700;

  color: #059669;

}



.sahsi-row__chevron {

  font-size: 20px;

  color: #64748b;

}



.sahsi-row__detail {

  padding: 8px 12px 12px;

  background: #fff;

  border-top: 1px solid #eef2f7;

}



.sahsi-detail-item {

  display: grid;

  grid-template-columns: 1fr auto auto;

  align-items: center;

  gap: 12px;

  padding: 10px 12px;

  border-radius: 8px;

  transition: background 0.15s;

}



.sahsi-detail-item:hover {

  background: #f8fafc;

}



.sahsi-detail-item + .sahsi-detail-item {

  border-top: 1px dashed #f1f5f9;

}



.sahsi-detail-item__type {

  font-size: 13px;

  color: #334155;

  font-weight: 500;

}



.sahsi-detail-item__amount {

  font-size: 13px;

  font-weight: 700;

  color: #0f172a;

  white-space: nowrap;

}



.sahsi-detail-item__btn {

  display: inline-flex;

  align-items: center;

  gap: 4px;

  padding: 5px 12px;

  border: 1px solid #bfdbfe;

  border-radius: 8px;

  background: #eff6ff;

  color: #2563eb;

  font-size: 12px;

  font-weight: 600;

  cursor: pointer;

  transition: background 0.15s;

}



.sahsi-detail-item__btn:hover {

  background: #dbeafe;

}



.sahsi-totals {

  border-top: 1px solid #eef2f7;

  background: #f8fafc;

  padding: 12px 22px 16px;

}



.sahsi-totals__row {

  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 16px;

  padding: 8px 0;

  font-size: 13px;

  color: #475569;

  border-bottom: 1px dashed #e2e8f0;

}



.sahsi-totals__row:last-child {

  border-bottom: none;

}



.sahsi-totals__row strong {

  font-size: 14px;

  font-weight: 700;

  color: #334155;

  white-space: nowrap;

}



.sahsi-totals__row--grand {

  margin-top: 4px;

  padding-top: 12px;

  border-top: 2px solid #cbd5e1;

  border-bottom: none;

  font-size: 14px;

  font-weight: 600;

  color: #0f172a;

}



.sahsi-totals__row--grand strong {

  font-size: 1.15rem;

  color: #059669;

}



@media (max-width: 767.98px) {

  .sahsi-filter__form {

    flex-direction: column;

    align-items: stretch;

  }



  .sahsi-field--company {

    flex: 1;

  }



  .sahsi-filter__dates {

    flex-direction: column;

    align-items: stretch;

  }



  .sahsi-filter__sep {

    display: none;

  }



  .sahsi-detail-item {

    grid-template-columns: 1fr;

    gap: 8px;

  }



  .sahsi-detail-item__btn {

    justify-self: start;

  }

}

</style>

